import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import { SubmittingWarningsForm } from './forms/submitting-warnings.form';
import { stages } from '../../notification-general-remarks-road-marking.routes';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-submitting-warnings-section',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent,
    StagesComponent,
    ValidationErrorsComponent
  ],
  providers: [
    SubmittingWarningsForm
  ],
  templateUrl: './submitting-warnings-section.component.html'
})
export class SubmittingWarningsSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  private router: Router = inject(Router);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private store$: Store = inject(Store);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public form: SubmittingWarningsForm = inject(SubmittingWarningsForm);

  private fetchApplication: Subscription = toObservable(this.application).subscribe((app) => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public onCancel(): void {
    this.router.navigate(['../lokalizacja'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.value,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
